'use client';

import { useCallback } from 'react';
import type { CheckoutPurchaseConfirmation } from '../types';

const CHECKOUT_SUBMITTED_TICKET_KEY = 'll-checkoutPurchaseConfirmation';

function useCheckoutSubmittedTicket() {
  const hasProducts = useCallback((products: CheckoutPurchaseConfirmation['products']): boolean => {
    return Boolean(products.lottery ?? products.scratchcard);
  }, []);

  const setCheckoutSubmittedTicket = useCallback((data: CheckoutPurchaseConfirmation) => {
    sessionStorage.setItem(CHECKOUT_SUBMITTED_TICKET_KEY, JSON.stringify(data));
  }, []);

  const getCheckoutSubmittedTicket = useCallback((): CheckoutPurchaseConfirmation | null => {
    if (typeof window === 'undefined') return null;
    const raw = sessionStorage.getItem(CHECKOUT_SUBMITTED_TICKET_KEY);
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw) as CheckoutPurchaseConfirmation;

      if (!parsed.products || !hasProducts(parsed.products)) {
        return null;
      }

      return parsed;
    } catch {
      return null;
    }
  }, [hasProducts]);

  const clearCheckoutSubmittedTicket = useCallback(() => {
    sessionStorage.removeItem(CHECKOUT_SUBMITTED_TICKET_KEY);
  }, []);

  return { setCheckoutSubmittedTicket, getCheckoutSubmittedTicket, clearCheckoutSubmittedTicket };
}

export { CHECKOUT_SUBMITTED_TICKET_KEY, useCheckoutSubmittedTicket };
